import React from "react";
import { CalendarDays } from "lucide-react";

import { hojeMenos } from "./formato";

const inicioDoMes = (desloc = 0) => { const d = new Date(); d.setDate(1); d.setMonth(d.getMonth() + desloc); return d.toLocaleDateString("sv-SE"); };
const fimDoMesPassado = () => { const d = new Date(); d.setDate(0); return d.toLocaleDateString("sv-SE"); };

export const ATALHOS = [
  { id: "7", rotulo: "7 dias", de: () => hojeMenos(6), ate: () => hojeMenos(0) },
  { id: "30", rotulo: "30 dias", de: () => hojeMenos(29), ate: () => hojeMenos(0) },
  { id: "90", rotulo: "90 dias", de: () => hojeMenos(89), ate: () => hojeMenos(0) },
  { id: "mes", rotulo: "Este mês", de: () => inicioDoMes(0), ate: () => hojeMenos(0) },
  { id: "mes_passado", rotulo: "Mês passado", de: () => inicioDoMes(-1), ate: fimDoMesPassado },
  { id: "tudo", rotulo: "Tudo", de: () => "2024-01-01", ate: () => hojeMenos(0) },
];

export default function FiltroPeriodo({ de, ate, onMudar, cor = "bg-primary text-primary-foreground" }) {
  const ativo = ATALHOS.find((a) => a.de() === de && a.ate() === ate)?.id;
  return (
    <div className="flex flex-wrap items-center gap-2" data-e2e="filtro-periodo">
      <div className="flex flex-wrap rounded-lg border p-0.5 bg-card">
        {ATALHOS.map((a) => (
          <button key={a.id} type="button" onClick={() => onMudar({ de: a.de(), ate: a.ate() })}
            className={`px-2.5 py-1 text-xs font-semibold rounded-md transition-colors ${ativo === a.id ? cor : "text-muted-foreground hover:text-foreground"}`}>
            {a.rotulo}
          </button>
        ))}
      </div>
      <label className="flex items-center gap-1.5 rounded-lg border bg-card px-2 py-1 text-xs">
        <CalendarDays className="w-3.5 h-3.5 text-muted-foreground" />
        <input type="date" value={de} max={ate} onChange={(e) => e.target.value && onMudar({ de: e.target.value })}
          className="bg-transparent outline-none tabular-nums" aria-label="Data inicial" />
        <span className="text-muted-foreground">até</span>
        <input type="date" value={ate} min={de} onChange={(e) => e.target.value && onMudar({ ate: e.target.value })}
          className="bg-transparent outline-none tabular-nums" aria-label="Data final" />
      </label>
    </div>
  );
}
